export enum ElementImportance {
    Main = "main",
    NavBarComponent = "nav-bar-component",
    NavBarSubComponent = "nav-bar-sub-component",
    NoNavBarComponent = "no-nav-bar-component",
}